<div ngModelGroup="addressDTO">
  <div class="d-flex flex-column gap-3">
    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityAddressDto.addressLine"
                   class="w-100"
                   formInlineError
                   id="addressLine"
                   name="addressLine"
                   bsInputText
                   required
                   type="text" data-testid="address-line-input">
            <label for="addressLine">{{'platform-administration.company.legal-entity.inputs.address.addressLine' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="row">
      <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityAddressDto.city"
                   class="w-100"
                   formInlineError
                   id="city"
                   name="city"
                   bsInputText
                   required
                   type="text" data-testid="city-input">
            <label for="city">{{'platform-administration.company.legal-entity.inputs.address.city' | translate}} *</label>
          </p-floatlabel>
    </div>

    <div class="d-flex flex-column gap-3">
      <div class="row">
        <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityAddressDto.state"
                   class="w-100"
                   formInlineError
                   id="state"
                   name="state"
                   bsInputText
                   type="text" data-testid="state-input">
            <label for="state">{{'platform-administration.company.legal-entity.inputs.address.state' | translate}}</label>
          </p-floatlabel>
      </div>

      <div class="row">
        <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityAddressDto.country"
                   class="w-100"
                   formInlineError
                   id="country"
                   name="country"
                   bsInputText
                   required
                   type="text" data-testid="country-input">
            <label for="country">{{'platform-administration.company.legal-entity.inputs.address.country' | translate}} *</label>
          </p-floatlabel>
      </div>

      <div class="row">
        <div class="col-lg-6 col-12 form-field">
          <p-floatlabel variant="on">
            <input [(ngModel)]="platformLegalEntityAddressDto.postalCode"
                   class="w-100"
                   formInlineError
                   id="postalCode"
                   name="postalCode"
                   bsInputText
                   required
                   type="text" data-testid="postal-code-input">
            <label for="postalCode">{{'platform-administration.company.legal-entity.inputs.address.postalCode' | translate}} *</label>
          </p-floatlabel>
      </div>
    </div>
  </div>

</div>


